export default __webpack_public_path__ + "static/media/fi-sr-quote-right.faff0936.svg";